<template>
    <div>
        <!--================Header Menu Area =================-->
        <header class="header_area">
            <div class="main_menu">
                <nav class="navbar navbar-expand-lg navbar-light">
                    <div class="container">
                        <!-- Brand and toggle get grouped for better mobile display -->
                        <a class="navbar-brand logo_h" href="/"><img src="../assets/logo-white.png" alt=""></a>
                        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>
                        <!-- Collect the nav links, forms, and other content for toggling -->
                        <div class="collapse navbar-collapse offset" id="navbarSupportedContent">
                            <ul class="nav navbar-nav menu_nav justify-content-center">
                                <li class="nav-item active"><a class="nav-link" href="http://cceo.com.mx/" target="_blank">Web Page</a></li>
                                <li class="nav-item"><a class="nav-link" href="https://45.33.38.174/" target="_blank">Open Project</a></li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
        <!--================Header Menu Area =================-->

        <!--================Home Banner Area =================-->
        <section class="home_banner_area">
            <div class="banner_inner">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="home_left_img">
                                <img class="img-fluid" src="../assets/banner/home-left.png" alt="">
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="banner_content">
                                <button @click="chido">Abrir GTA</button>
                                <h2>
                                    We moved!,<br>
                                    now our page is: <br>
                                    <a href="http://www.cceo.com.mx/en" target="_blank">cceo.com.mx</a>
                                </h2>
                                <p>
                                    We are passionate about technology and the development of projects that improves
                                    our environment. We are specialists in web design and in mobile apps and web
                                    platforms development
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--================End Home Banner Area =================-->
    </div>
</template>

<script>
    export default {
        name: 'WebPage',
	methods:{
		chido(){
	                window.location = 'intent://grupotextil.com.mx/#Intent;scheme=success.payment;package=com.grupotextil.app;end';
		}
	}
    }
</script>

<style src="./WebPage.scss" lang="scss" scoped />
